/*eslint-disable*/
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import productionPlanServices from '@/Services/Analytics Services/production-plan.services';
import multipleConfigPo from '../multiplePoConfig';
import { notificationServices } from '@/Services';
import {
	openConfirmation,
	openConfirmationDataEntry,
} from '../utils/confirmation';
import {
	getHeadersandRows,
	getQuantityConvertedBasedUnit,
	getLppUpdatePayload,
	transformLongTermPlanApiResponse,
	calculateRowVariance,
} from '../utils/utils';
import moment from 'moment';
import { convertToLowerUnit, getHigherUnitAndQuantity } from '@/Helpers';

export const buttonConfig = {
	multipleOrder: {
		getDisabled: ({ state, tableData }) => {
			return !state?.fromStore || tableData?.rows?.length === 0;
		},
		onClick: ({
			state,
			tableData,
			setConfirmationModal,
			lists,
			selectedPOs,
			handleClose,
			changeQtyRef,
			ppId,
			editMode,
			orderwise,
		}) => {
			openConfirmation({
				state,
				tableData,
				setConfirmationModal,
				lists,
				heading: 'Confirm Order Generation',
				message: `Are you sure you want to ${editMode || orderwise ? 'edit' : 'create'
					} the order?`,
				handleCloseConfirmation: () => {
					setConfirmationModal({
						isOpen: false,
						message: '',
						heading: '',
					});
				},
				handleConfirmSave: async () => {
					setConfirmationModal((prev) => ({
						...prev,
						isLoading: true,
					}));
					try {
						if (changeQtyRef.current && (editMode || orderwise)) {
							changeQtyRef.current = false;
							handleClose();
							return;
						}
						const orderWiseIds = orderwise
							? tableData?.headers
								?.filter((h) => h.orderId)
								.map((h) => h.id)
							: [];
						const cancelIds = orderwise
							? orderWiseIds
							: selectedPOs?.map((item) => item?.id);

						const data = multipleConfigPo?.deserializer(
							state,
							tableData
						);
						const response =
							await inventoryAnalyticsServices?.addVendorPO({
								data: {
									...data,
									...(editMode || orderwise
										? { cancelPoIds: cancelIds }
										: {}),
									...(ppId && (editMode || orderwise)
										? { cancelPPId: ppId }
										: {}),
								},
							});
						if (response?.statusCode === 200) {
							notificationServices.generateNotification({
								type: 'success',
								message: response?.message,
							});
							handleClose();
						}
					} catch (error) {
						console.error(error);
					} finally {
						setConfirmationModal((prev) => ({
							...prev,
							isLoading: false,
						}));
					}
				},
			});
		},
	},
	generateProductionPlan: {
		getDisabled: ({ state, tableData }) => {
			return !state?.fromStore || tableData?.rows?.length === 0;
		},
		onClick: ({
			state,
			lists,
			tableData,
			setConfirmationModal,
			proceedGenerateProductionPlan,
			selectedPOs,
			ppId,
			editMode,
			changeQtyRef,
		}) => {
			openConfirmation({
				state,
				tableData,
				setConfirmationModal,
				lists,
				heading: 'Confirm Order Generation',
				message:
					'Are you sure you want to generate all the orders ? This will also create a production plan for all the orders',
				handleCloseConfirmation: () => {
					setConfirmationModal({
						isOpen: false,
						message: '',
						heading: '',
					});
				},
				handleConfirmSave: async () => {
					setConfirmationModal((prev) => ({
						...prev,
						isLoading: true,
					}));
					try {
						if (changeQtyRef.current && editMode) {
							changeQtyRef.current = false;
							proceedGenerateProductionPlan(selectedPOs);
							return;
						}
						const data = multipleConfigPo?.deserializer(
							state,
							tableData
						);
						const response =
							await inventoryAnalyticsServices?.addVendorPO({
								data: {
									...data,
									...(editMode
										? {
											cancelPoIds: selectedPOs?.map(
												(item) => item?.id
											),
										}
										: {}),
									...(ppId && editMode
										? { cancelPPId: ppId }
										: {}),
								},
							});
						if (response?.statusCode === 200) {
							notificationServices.generateNotification({
								type: 'success',
								message: response?.message,
							});
							proceedGenerateProductionPlan(
								response?.data?.orders
							);
						}
					} catch (error) {
						console.error(error);
					} finally {
						setConfirmationModal((prev) => ({
							...prev,
							isLoading: false,
						}));
					}
				},
			});
		},
	},
	saveProductionData: {
		onClick: ({
			state,
			lists,
			tableData,
			setConfirmationModal,
			handleClose,
		}) => {
			openConfirmationDataEntry({
				state,
				tableData,
				setConfirmationModal,
				lists,
				heading: 'Confirm Production Data Entry',
				message: 'Are you sure you want to save the production data?',
				handleCloseConfirmation: () => {
					setConfirmationModal({
						isOpen: false,
						message: '',
						heading: '',
					});
				},
				handleConfirmSave: async () => {
					setConfirmationModal((prev) => ({
						...prev,
						isLoading: true,
					}));
					const manualProduction = {};
					const dateRange = {
						from: moment(state?.poCreationDate).format(
							'YYYY-MM-DD'
						),
						to: moment(state?.poCreationDate).format('YYYY-MM-DD'),
					};
					const notificationId =
						notificationServices.generateNotification({
							type: 'loading',
							message: 'Saving production data...',
						});
					tableData?.rows?.forEach((row) => {
						Object.entries(row)
							?.filter(
								([key, value]) =>
									![
										'Actions',
										'Item Name',
										'S.No',
										'SkuCode',
										'Total',
										'itemId',
									].includes(key)
							)
							?.forEach(([key, val]) => {
								if (val?.noOrder) return;
								manualProduction[val?.itemId] = {
									...manualProduction[val?.itemId],
									[val?.storeId]: {
										poIds: val?.poIds,
										qty: getQuantityConvertedBasedUnit(
											val?.qty,
											val?.unit,
											'lower'
										),
									},
								};
							});
					});
					try {
						const response =
							await inventoryAnalyticsServices?.saveProductionManualEntry(
								{
									data: {
										dateRange,
										manualProduction,
									},
								}
							);
						if (response?.statusCode === 200) {
							notificationServices.generateNotification({
								type: 'success',
								message: response?.message,
							});
							if (response?.errors?.length > 0) {
								notificationServices?.generateNotification({
									type: 'warning',
									message: `${response?.errors?.[0]} Value is not updated`,
								});
							}
							handleClose();
						}
					} catch (error) {
						notificationServices.generateNotification({
							type: 'error',
							message:
								error?.message ||
								error ||
								'Something went wrong',
						});
					} finally {
						notificationServices.closeNotification(notificationId);
						setConfirmationModal((prev) => ({
							...prev,
							isLoading: false,
						}));
					}
				},
			});
		},
	},
	reset: {
		getDisabled: ({ tableData, state, originalRowsRef }) => {
			const currentStep = state?.currentStep || 1;
			if (currentStep === 1) {
				const rows = originalRowsRef?.current || tableData?.rows || [];
				return !rows.some((row) => row?.qty && row.qty !== '');
			}
			if (currentStep === 2) {
				// Disable if no rows have frequency or date selections
				return !tableData?.rows?.some(
					(row) =>
						row?.frequency ||
						Object.keys(row).some(
							(key) =>
								key.startsWith('date_') && row[key] === true
						)
				);
			}
		},
		onClick: ({
			tableData,
			setTableData,
			state,
			prevTableData,
			setWorkerAllocations,
		}) => {
			const currentStep = state?.currentStep || 1;

			if (currentStep === 1) {
				// Step 1: Reset all qty values to empty
				const resetRows = tableData?.rows?.map((row) => ({
					...row,
					qty: '',
				}));
				setTableData({
					...tableData,
					rows: resetRows,
				});
			} else if (currentStep === 2) {
				const resetRows = tableData?.rows?.map((row) => {
					const newRow = { ...row };
					newRow.frequency = '';
					delete newRow.repeatDaysNumber;
					delete newRow.increaseHeight;
					Object.keys(newRow).forEach((key) => {
						if (key.startsWith('date_')) {
							newRow[key] = false;
						}
					});
					return newRow;
				});
				setTableData({
					...tableData,
					rows: resetRows,
				});
				setWorkerAllocations({});
			} else if (currentStep === 3) {
				const step2Data = prevTableData?.['2'];
				if (step2Data) {
					const resetRows = tableData?.rows?.map((row, index) => {
						const step2Row = step2Data?.rows?.[index];
						if (!step2Row) return row;

						const selectedDates = Object.entries(step2Row)?.filter(
							([key, value]) =>
								key.startsWith('date_') && value === true
						);
						const selectedDateCount = selectedDates?.length || 0;
						const totalQty = parseFloat(step2Row?.qty) || 0;
						const batchSize = parseFloat(row?.batch) || 0;
						const unit = row?.unit?.toLowerCase();

						const dateValues = {};
						const dateHeaders =
							tableData?.headers?.filter((h) =>
								h.id?.startsWith('date_')
							) || [];
						dateHeaders.forEach((dh) => {
							dateValues[dh.id] = false;
						});
						if (selectedDateCount > 0) {
							if (batchSize > 0) {
								const numFullBatches = Math.floor(
									totalQty / batchSize
								);
								const remainder =
									totalQty - numFullBatches * batchSize;

								const baseBatchesPerDay = Math.floor(
									numFullBatches / selectedDateCount
								);
								let extraBatches =
									numFullBatches % selectedDateCount;

								selectedDates.forEach(([key], index) => {
									let dailyQty =
										baseBatchesPerDay * batchSize;
									if (extraBatches > 0) {
										dailyQty += batchSize;
										extraBatches--;
									}
									if (index === selectedDateCount - 1) {
										dailyQty += remainder;
									}
									dateValues[key] = dailyQty;
								});
							} else {
								let qtyPerDate = totalQty / selectedDateCount;
								if (['count', 'pc', 'pcs'].includes(unit)) {
									qtyPerDate = Math.floor(qtyPerDate);
								}
								selectedDates?.forEach(([key]) => {
									dateValues[key] = qtyPerDate;
								});
							}
						}

						return {
							...row,
							...dateValues,
							planned: totalQty,
						};
					});
					setTableData({
						...tableData,
						rows: resetRows,
					});
				}
			}
		},
	},
	nextStep: {
		getDisabled: ({ tableData, state, originalRowsRef }) => {
			const currentStep = state?.currentStep || 1;
			const rows = originalRowsRef?.current || tableData?.rows || [];
			if (currentStep === 1) {
				const hasQty = rows.some((row) => row?.qty && row.qty !== '');
				if (!hasQty) return true;

				// Check for batch multiple validation
				const isInvalid = rows.some((row) => {
					const qty = parseFloat(row.qty);
					const batch = parseFloat(row.batch);
					return (
						qty > 0 &&
						batch > 0 &&
						(qty * 1000) % (batch * 1000) !== 0
					);
				});
				return isInvalid;
			}
			if (currentStep === 2) {
				const tableRows = tableData?.rows || [];
				return !tableRows.every((row) =>
					Object.keys(row).some(
						(key) => key.startsWith('date_') && row[key] === true
					)
				);
			}
			if (currentStep === 3) {
				// Check for batch multiple validation in date columns
				const tableRows = tableData?.rows || [];
				const today = moment().startOf('day');
				const isInvalid = tableRows.some((row) => {
					const batch = parseFloat(row.batch);
					if (!batch || batch <= 0) return false;

					return Object.entries(row).some(([key, val]) => {
						if (
							key.startsWith('date_') &&
							val !== false &&
							val !== ''
						) {
							const dateStr = key.replace('date_', '');
							const isPastDate = moment(dateStr).isBefore(today);
							if (isPastDate) return false;

							const qty = parseFloat(val);
							return (
								qty > 0 && (qty * 1000) % (batch * 1000) !== 0
							);
						}
						return false;
					});
				});
				return isInvalid;
			}
		},
		onClick: ({
			state,
			tableData,
			prevTableData,
			setConfirmationModal,
			dispatch,
			setPrevTableData,
			setTableData,
			handleClose,
			lists,
			originalRowsRef,
			setSearchQuery,
			workerAllocations,
		}) => {
			const currentStep = state?.currentStep;
			const nextStep = currentStep + 1;

			// --- Phase 3: Save Plan ---
			if (currentStep === 3) {
				const dateHeaders =
					tableData?.headers?.filter((h) =>
						h.id?.startsWith('date_')
					) || [];
				const sortedDates = dateHeaders
					.map((h) => h.id.replace('date_', ''))
					.sort();
				const startDate = sortedDates[0] || '';
				const endDate = sortedDates[sortedDates.length - 1] || '';

				const labourCounts = [];
				const holidays = [];

				if (workerAllocations) {
					Object.entries(workerAllocations).forEach(
						([date, allocation]) => {
							const isHoliday =
								allocation.isHoliday !== undefined &&
								allocation.isHoliday;
							if (isHoliday) {
								holidays.push({ date });
							} else {
								if (allocation.gradeA)
									labourCounts.push({
										date,
										grade: 'GRADE_A',
										labourCount: parseInt(
											allocation.gradeA
										),
									});
								if (allocation.gradeB)
									labourCounts.push({
										date,
										grade: 'GRADE_B',
										labourCount: parseInt(
											allocation.gradeB
										),
									});
								if (allocation.gradeC)
									labourCounts.push({
										date,
										grade: 'GRADE_C',
										labourCount: parseInt(
											allocation.gradeC
										),
									});
							}
						}
					);
				}

				const saveData = {
					name: state?.planName,
					type: state?.planLength === 'Weekly' ? 'week' : 'month',
					start_date: startDate,
					end_date: endDate,
					storeId: state?.kitchen,
					shiftId:
						state?.shift === -999 ? null : state?.shift || null,
					labourCounts,
					holidays,
					config: tableData?.rows?.map((row) => {
						const plannedQtys = [];
						dateHeaders.forEach((header) => {
							const dateKey = header.id;
							const dateValue = dateKey.replace('date_', '');
							const qty = row[dateKey];
							plannedQtys.push({
								date: dateValue,
								qty: convertToLowerUnit(
									row?.originalUnit,
									parseFloat(qty) || 0
								),
								enabled: qty !== false,
								idx: header?.name,
							});
						});
						return {
							productId: row?._productId,
							variantId: row?._variantId || null,
							totalQty: convertToLowerUnit(
								row?.originalUnit,
								parseFloat(row?.qty) || 0
							),
							frequency: row?.frequency || 'daily',
							plannedQtys,
						};
					}),
				};

				const kitchenName =
					lists?.kitchenList?.find(
						(k) =>
							k.id === state?.kitchen ||
							k.value === state?.kitchen
					)?.label || '';
				const periodLabel = moment()
					.month(state?.planPeriod)
					.format('MMMM YYYY');
				const shiftLabel =
					lists?.shiftList?.find(
						(s) => s.id === state?.shift || s.value === state?.shift
					)?.label || '';

				setConfirmationModal({
					isOpen: true,
					heading: 'Save Production Long Term Plan',
					message: `Are you sure you want to save the ${state?.planLength || ''
						} production plan "${state?.planName
						}" for "${kitchenName}" kitchen, period "${periodLabel}" and shift "${shiftLabel}"?`,
					handleConfirmSave: async () => {
						setConfirmationModal((prev) => ({
							...prev,
							isLoading: true,
						}));
						try {
							const response =
								await productionPlanServices.saveLongTermProductionPlan(
									{ data: saveData }
								);
							if (
								response?.statusCode === 200 ||
								response?.status === 'success'
							) {
								notificationServices.generateNotification({
									type: 'success',
									message:
										'Production plan saved successfully!',
								});
								handleClose?.();
							} else {
								notificationServices.generateNotification({
									type: 'error',
									message:
										response?.message ||
										'Failed to save production plan.',
								});
							}
						} catch (error) {
							console.error(
								'Error saving production plan:',
								error
							);
							notificationServices.generateNotification({
								type: 'error',
								message:
									'Failed to save production plan. Please try again.',
							});
						}
						setConfirmationModal({
							isOpen: false,
							isLoading: false,
						});
					},
					handleCloseConfirmation: () =>
						setConfirmationModal({
							isOpen: false,
							isLoading: false,
						}),
				});
				return;
			}

			// --- Step Restoration & Validation ---
			let activeTableData = tableData;

			if (currentStep === 1) {
				const requiredFields = ['planName', 'kitchen', 'planPeriod'];
				const missingFields = requiredFields.filter(
					(field) => !state?.[field]
				);
				if (missingFields.length > 0) {
					notificationServices.generateNotification({
						type: 'warning',
						message:
							'Please fill in the required details before proceeding.',
					});
					return;
				}

				// Restore full data if search was active
				if (originalRowsRef.current) {
					tableData.rows.forEach((currentRow) => {
						const originalIndex = originalRowsRef.current.findIndex(
							(row) => row._variantId === currentRow._variantId
						);
						if (originalIndex !== -1) {
							originalRowsRef.current[originalIndex] = {
								...currentRow,
							};
						}
					});
					activeTableData = {
						...tableData,
						rows: originalRowsRef.current,
					};
					originalRowsRef.current = null;
					setSearchQuery('');
				}
			}

			// --- Next Step Initialization ---
			let finalHeaders = [];
			let finalRows = [];

			if (nextStep === 2) {
				const filledRows = activeTableData?.rows?.filter(
					(row) => row?.qty && row.qty !== ''
				);
				const nextStepData = prevTableData?.[nextStep];

				if (nextStepData) {
					const cachedHeaders = nextStepData.headers || [];
					const firstDateHeader = cachedHeaders.find((h) =>
						h.id?.startsWith('date_')
					);
					const cachedMonthCode = firstDateHeader
						? moment(
							firstDateHeader.id.replace('date_', '')
						).month()
						: -1;
					const isMonthChanged =
						cachedMonthCode !== -1 &&
						cachedMonthCode !== state.planPeriod;

					if (isMonthChanged) {
						const { headers: freshHeaders } = getHeadersandRows(
							nextStep,
							activeTableData,
							state
						);
						let updatedRows = nextStepData.rows.map((cachedRow) => {
							const newRow = { ...cachedRow };
							Object.keys(cachedRow).forEach((key) => {
								if (key.startsWith('date_')) delete newRow[key];
							});

							const oldDateHeaders = cachedHeaders.filter((h) =>
								h.id.startsWith('date_')
							);
							const newDateHeaders = freshHeaders.filter((h) =>
								h.id.startsWith('date_')
							);

							if (cachedRow.frequency === 'daily') {
								newDateHeaders.forEach(
									(h) => (newRow[h.id] = true)
								);
							} else {
								oldDateHeaders.forEach((oh) => {
									if (cachedRow[oh.id] === true) {
										const dayNum = moment(
											oh.id.replace('date_', '')
										).date();
										const nh = newDateHeaders.find(
											(h) =>
												moment(
													h.id.replace('date_', '')
												).date() === dayNum
										);
										if (nh) newRow[nh.id] = true;
									}
								});
							}

							const currentRow = filledRows.find(
								(r) =>
									r._productId === cachedRow._productId &&
									r._variantId === cachedRow._variantId
							);
							if (currentRow && currentRow.qty !== cachedRow.qty)
								newRow.qty = currentRow.qty;
							if (newRow.repeatDaysNumber == null)
								newRow.repeatDaysNumber = 2;

							return newRow;
						});

						const existingRowIds = updatedRows.map(
							(r) => `${r._productId}_${r._variantId}`
						);
						const newRows = filledRows.filter(
							(row) =>
								!existingRowIds.includes(
									`${row._productId}_${row._variantId}`
								)
						);
						if (newRows.length > 0) {
							const { rows: newRowsData } = getHeadersandRows(
								nextStep,
								{ ...activeTableData, rows: newRows },
								state
							);
							updatedRows = [...updatedRows, ...newRowsData];
						}

						finalHeaders = freshHeaders;
						finalRows = updatedRows.map((row, index) => ({
							...row,
							'S.No': index + 1,
						}));
					} else {
						// Month not changed, just sync quantities and add new rows
						const existingRowIds = nextStepData.rows.map(
							(r) => `${r._productId}_${r._variantId}`
						);
						let updatedRows = nextStepData.rows.filter((row) =>
							filledRows.find(
								(r) =>
									r._productId === row._productId &&
									r._variantId === row._variantId
							)
						);

						updatedRows = updatedRows.map((cachedRow) => {
							const currentRow = filledRows.find(
								(r) =>
									r._productId === cachedRow._productId &&
									r._variantId === cachedRow._variantId
							);
							const mergedRow = { ...cachedRow };
							if (currentRow && currentRow.qty !== cachedRow.qty)
								mergedRow.qty = currentRow.qty;
							if (mergedRow.repeatDaysNumber == null)
								mergedRow.repeatDaysNumber = 2;
							return mergedRow;
						});

						const newRows = filledRows.filter(
							(row) =>
								!existingRowIds.includes(
									`${row._productId}_${row._variantId}`
								)
						);
						if (newRows.length > 0) {
							const { rows: newRowsData } = getHeadersandRows(
								nextStep,
								{ ...activeTableData, rows: newRows },
								state
							);
							updatedRows = [...updatedRows, ...newRowsData];
						}

						finalHeaders = nextStepData.headers;
						finalRows = updatedRows.map((row, index) => ({
							...row,
							'S.No': index + 1,
						}));
					}
				}
			} else if (nextStep === 3) {
				const nextStepData = prevTableData?.[nextStep];
				const cachedStep2Data = prevTableData?.[2];

				if (nextStepData && cachedStep2Data) {
					const firstStep3DateHeader = nextStepData.headers.find(
						(h) => h.id?.startsWith('date_')
					);
					const cachedStep3MonthCode = firstStep3DateHeader
						? moment(
							firstStep3DateHeader.id.replace('date_', '')
						).month()
						: -1;
					const isStep3MonthChanged =
						cachedStep3MonthCode !== -1 &&
						cachedStep3MonthCode !== state.planPeriod;

					const hasSourceChanged = activeTableData.rows.some(
						(currentRow) => {
							const cachedRow = cachedStep2Data.rows.find(
								(r) =>
									r._productId === currentRow._productId &&
									r._variantId === currentRow._variantId
							);
							if (!cachedRow) return true;
							if (
								currentRow.qty !== cachedRow.qty ||
								currentRow.frequency !== cachedRow.frequency ||
								currentRow.repeatDaysNumber !==
								cachedRow.repeatDaysNumber
							)
								return true;

							const currentDates = Object.keys(currentRow).filter(
								(k) =>
									k.startsWith('date_') &&
									currentRow[k] === true
							);
							const cachedDates = Object.keys(cachedRow).filter(
								(k) =>
									k.startsWith('date_') &&
									cachedRow[k] === true
							);
							return (
								currentDates.length !== cachedDates.length ||
								currentDates.some(
									(d) => !cachedDates.includes(d)
								)
							);
						}
					);

					const currentRowIds = activeTableData.rows.map(
						(r) => `${r._productId}_${r._variantId}`
					);
					const cachedRowIds = cachedStep2Data.rows.map(
						(r) => `${r._productId}_${r._variantId}`
					);
					const rowsChanged =
						currentRowIds.length !== cachedRowIds.length ||
						currentRowIds.some((id) => !cachedRowIds.includes(id));

					if (
						!hasSourceChanged &&
						!rowsChanged &&
						!isStep3MonthChanged
					) {
						finalHeaders = nextStepData.headers;
						finalRows = nextStepData.rows;
					}
				}
			}

			// If finalHeaders/Rows not yet set by optimized logic, generate them fresh
			if (finalHeaders.length === 0) {
				const { headers, rows } = getHeadersandRows(
					nextStep,
					activeTableData,
					state
				);
				finalHeaders = headers;
				finalRows = rows;
			}

			// Ensure past dates are false for Step 2
			if (nextStep === 2) {
				finalRows = finalRows.map((row) => {
					const updatedRow = { ...row };
					Object.keys(updatedRow).forEach((key) => {
						if (key.startsWith('date_')) {
							const isPastDate = moment(
								key.replace('date_', '')
							).isBefore(moment(), 'day');
							if (isPastDate) updatedRow[key] = false;
						}
					});
					return updatedRow;
				});
			}

			// --- Final State Update ---
			setTableData({ headers: finalHeaders, rows: finalRows });
			setPrevTableData((prev) => ({
				...prev,
				[currentStep]: activeTableData,
			}));
			dispatch({ type: 'SET_STATE', payload: { currentStep: nextStep } });
		},
	},
	previousStep: {
		getDisabled: ({ state }) => {
			return state.currentStep <= 1;
		},
		onClick: ({
			state,
			dispatch,
			tableData,
			setTableData,
			prevTableData,
			setPrevTableData,
		}) => {
			const currentStep = state?.currentStep;
			const prevStep = currentStep - 1;
			const previousData = prevTableData[prevStep];
			if (currentStep === 2) {
				const hasFilledValue = tableData?.rows?.some(
					(row) =>
						row?.frequency ||
						Object.keys(row).some(
							(key) =>
								key.startsWith('date_') && row[key] === true
						)
				);
				if (hasFilledValue) {
					setPrevTableData((prev) => ({
						...prev,
						[currentStep]: tableData,
					}));
				}
			} else if (currentStep === 3) {
				setPrevTableData((prev) => ({
					...prev,
					[currentStep]: tableData,
				}));
			}
			if (previousData) {
				setTableData(previousData);
				dispatch({
					type: 'SET_STATE',
					payload: {
						currentStep: prevStep,
					},
				});
			} else {
				console.log('No previous table data found for step', prevStep);
				dispatch({
					type: 'SET_STATE',
					payload: {
						currentStep: prevStep,
					},
				});
			}
		},
	},
	longTermEditSave: {
		getDisabled: ({ tableData, state }) => {
			const today = moment().startOf('day');
			const isInvalid = tableData?.rows?.some((row) => {
				const batch = parseFloat(row.batch);
				if (!batch || batch <= 0) return false;

				return Object.entries(row).some(([key, val]) => {
					if (
						key.startsWith('date_') &&
						val !== false &&
						val !== ''
					) {
						const dateStr = key.replace('date_', '');
						const isPastDate = moment(dateStr).isBefore(today);
						const hasGeneratedPlan = state?.generatedPlans?.some(
							(plan) =>
								moment(plan.scheduledAt).isSame(
									moment(dateStr),
									'day'
								)
						);

						if (isPastDate || hasGeneratedPlan) return false;

						const qty = parseFloat(val);
						return qty > 0 && (qty * 1000) % (batch * 1000) !== 0;
					}
					return false;
				});
			});
			return isInvalid;
		},
		onClick: ({
			state,
			tableData,
			setConfirmationModal,
			handleClose,
			changeQtyRef,
			setTableData,
			dispatch,
			productList,
			batches,
			workerAllocations,
			lists,
		}) => {
			const kitchenName =
				lists?.kitchenList?.find(
					(k) => k.id === state?.kitchen || k.value === state?.kitchen
				)?.label || '';
			const periodLabel = moment()
				.month(state?.planPeriod)
				.format('MMMM YYYY');
			const shiftLabel =
				lists?.shiftList?.find(
					(s) => s.id === state?.shift || s.value === state?.shift
				)?.label || '';

			setConfirmationModal({
				isOpen: true,
				heading: 'Save Production Long Term Plan',
				message: `Are you sure you want to save the ${state?.planLength || ''
					} production plan "${state?.planName
					}" for "${kitchenName}" kitchen, period "${periodLabel}" and shift "${shiftLabel}"?`,
				handleConfirmSave: async () => {
					setConfirmationModal((prev) => ({
						...prev,
						isLoading: true,
					}));
					try {
						const planId = state?.planId;
						const payload = getLppUpdatePayload(tableData, planId, workerAllocations);
						console.log('Update payload:', payload);

						const res =
							await productionPlanServices.updateLongTermProductionPlan(
								{ data: payload }
							);

						if (res?.statusCode === 200 || res?.status === 200) {
							notificationServices.generateNotification({
								type: 'success',
								message:
									'Production plan updated successfully!',
							});

							// Fetch the updated plan to refresh the view
							const refreshRes =
								await productionPlanServices.getLongTermProductionPlan(
									{
										params: { id: planId },
									}
								);

							if (refreshRes?.statusCode === 200) {
								const { headers, rows, initialState } =
									transformLongTermPlanApiResponse(
										refreshRes.data,
										productList,
										batches
									);
								setTableData({ headers, rows });
								changeQtyRef.current = true;
								dispatch({
									type: 'SET_STATE',
									payload: { ...initialState },
								});
							}
						} else {
							notificationServices.generateNotification({
								type: 'error',
								message:
									res?.message ||
									'Failed to update production plan.',
							});
						}
					} catch (err) {
						notificationServices.generateNotification({
							type: 'error',
							message:
								err?.message ||
								'An error occurred while updating the plan.',
						});
					} finally {
						setConfirmationModal({
							isOpen: false,
							isLoading: false,
						});
					}
				},
				handleCloseConfirmation: () => {
					setConfirmationModal({ isOpen: false, isLoading: false });
				},
			});
		},
	},
	longTermRecalculate: {
		onClick: ({ state, tableData, setTableData }) => {
			const today = moment().startOf('day');
			const dateHeaders =
				tableData?.headers?.filter((h) => h.id?.startsWith('date_')) ||
				[];
			const futureDateKeys = dateHeaders
				.filter((h) => {
					const date = moment(h.id.replace('date_', '')).startOf(
						'day'
					);
					return date.isAfter(today);
				})
				.map((h) => h.id);

			if (futureDateKeys.length === 0) {
				notificationServices.generateNotification({
					type: 'warning',
					message: 'No remaining dates to redistribute variance.',
				});
				return;
			}

			const updatedRows = tableData?.rows?.map((row) => {
				const updatedRow = { ...row };
				const originalUnit = updatedRow.originalUnit;
				const totalTarget = updatedRow._totalTargetQuantity || 0;

				const variance = calculateRowVariance(
					updatedRow,
					totalTarget,
					originalUnit
				);
				if (parseFloat(variance) === 0) return updatedRow;

				const batch = parseFloat(updatedRow.batch) || 0;
				const varianceInBase = convertToLowerUnit(
					originalUnit,
					variance
				);

				const availableFutureDates = dateHeaders
					?.filter((col) => {
						const date = moment(
							col.id.replace('date_', '')
						).startOf('day');
						return (
							date.isSameOrAfter(today) &&
							updatedRow[col.id] !== false
						);
					})
					?.map((col) => col.id);

				if (availableFutureDates.length === 0) return updatedRow;

				// Calculate total batches to adjust
				let batchesInt =
					batch > 0
						? Math.ceil(Math.abs(variance) / batch)
						: Math.ceil(Math.abs(variance));

				if (variance < 0) {
					// -ve variance (Shortage): ADD production. Prioritize cells with zero qty, else distribute across all remaining dates
					const zeroQtyKeys = availableFutureDates.filter(
						(key) =>
							!updatedRow[key] ||
							parseFloat(updatedRow[key]) === 0
					);
					const targetKeys =
						zeroQtyKeys.length > 0
							? zeroQtyKeys
							: availableFutureDates;

					const batchesPerDay = Math.floor(
						batchesInt / targetKeys.length
					);
					let extraBatches = batchesInt % targetKeys.length;

					targetKeys.forEach((key, index) => {
						const dayAdjustmentBatches =
							batchesPerDay + (index < extraBatches ? 1 : 0);
						if (dayAdjustmentBatches > 0) {
							const currentDisplayQty =
								parseFloat(updatedRow[key]) || 0;
							const adjustment =
								dayAdjustmentBatches * (batch > 0 ? batch : 1);
							const targetQty = currentDisplayQty + adjustment;
							// Enforce batch-aligned ceiling
							updatedRow[key] =
								batch > 0
									? Math.ceil(targetQty / batch) * batch
									: Math.ceil(targetQty);
							updatedRow[`_touched_${key}`] = true;
						}
					});
				} else if (variance > 0) {
					// +ve variance (Excess): REDUCE production. Exhaustively reduce cell by cell, searching backwards
					let remainingBatches = batchesInt;
					for (const key of [...availableFutureDates].reverse()) {
						if (remainingBatches <= 0) break;
						const currentDisplayQty =
							parseFloat(updatedRow[key]) || 0;
						if (currentDisplayQty <= 0) continue;

						if (batch > 0) {
							const availableBatches = Math.floor(
								currentDisplayQty / batch
							);
							const takeBatches = Math.min(
								remainingBatches,
								availableBatches
							);
							if (takeBatches > 0) {
								const targetQty =
									currentDisplayQty - takeBatches * batch;
								updatedRow[key] = Math.max(
									0,
									batch > 0
										? Math.ceil(targetQty / batch) * batch
										: Math.ceil(targetQty)
								);
								remainingBatches -= takeBatches;
								updatedRow[`_touched_${key}`] = true;
							}
						} else {
							const take = Math.min(
								remainingBatches,
								currentDisplayQty
							);
							if (take > 0) {
								const targetQty = currentDisplayQty - take;
								updatedRow[key] = Math.max(
									0,
									Math.ceil(targetQty)
								);
								remainingBatches -= take;
								updatedRow[`_touched_${key}`] = true;
							}
						}
					}
					// If still batches left and no non-zero cells found, adjust the last available cell anyway
					if (remainingBatches > 0) {
						const lastKey =
							availableFutureDates[
							availableFutureDates.length - 1
							];
						const currentDisplayQty =
							parseFloat(updatedRow[lastKey]) || 0;
						const adjustment =
							remainingBatches * (batch > 0 ? batch : 1);
						updatedRow[lastKey] = Math.max(
							0,
							currentDisplayQty - adjustment
						);
						updatedRow[`_touched_${lastKey}`] = true;
					}
				}

				updatedRow.variance = calculateRowVariance(
					updatedRow,
					totalTarget,
					originalUnit
				);

				let rowTotalProductionBase = 0;
				Object.entries(updatedRow).forEach(([key, value]) => {
					if (key.startsWith('date_')) {
						const dateStr = key.replace('date_', '');
						const entryDate = moment(dateStr).startOf('day');
						if (entryDate.isBefore(today)) {
							const displayFulfilled =
								parseFloat(updatedRow[`_fulfilled_${key}`]) ||
								0;
							rowTotalProductionBase += convertToLowerUnit(
								originalUnit,
								displayFulfilled
							);
						} else {
							const displayPlanned =
								value === false ? 0 : parseFloat(value) || 0;
							rowTotalProductionBase += convertToLowerUnit(
								originalUnit,
								displayPlanned
							);
						}
					}
				});

				const [displayFinalProduction] = getHigherUnitAndQuantity(
					originalUnit,
					rowTotalProductionBase,
					false
				);
				updatedRow.finalProduction = displayFinalProduction;

				return updatedRow;
			});

			setTableData({
				...tableData,
				rows: updatedRows,
			});

			notificationServices.generateNotification({
				type: 'success',
				message: 'Recalculated variances for all rows.',
			});
		},
	},
	multipleBuyerOrder: {
		getDisabled: ({ state, tableData }) => {
			return state?.buyer?.length === 0 || !state?.fromStore || !state?.expectedDeliveryDate || tableData?.rows?.length === 0;
		},
		onClick: ({
			state,
			tableData,
			setConfirmationModal,
			lists,
			handleClose,
			changeQtyRef,
			editMode,
		}) => {
			const redRows = tableData.rows.filter((row) => row._isNotFound);
			if (redRows.length > 0) {
				notificationServices.generateNotification({
					type: 'warning',
					message: `Cannot submit data. Please select products for ${redRows.length} red-highlighted items.`,
				});

				return;
			}
			setConfirmationModal({
				isOpen: true,
				heading: 'Save Multiple Buyer Order',
				message: `Are you sure you want to save the multiple buyer order?`,
				handleConfirmSave: async () => {
					setConfirmationModal((prev) => ({
						...prev,
						isLoading: true,
					}));
					try {
						const data = multipleConfigPo?.buyerDeserlizer(
							state,
							tableData
						);
						const response =
							await inventoryAnalyticsServices?.addVendorPO({
								data: {
									...data,
								},
							});
						if (response?.statusCode === 200) {
							notificationServices.generateNotification({
								type: 'success',
								message: response?.message,
							});
							handleClose();
						}
					} catch (error) {
						notificationServices.generateNotification({
							type: 'error',
							message:
								error?.message ||
								error ||
								'Something went wrong',
						});
					} finally {
						setConfirmationModal((prev) => ({
							...prev,
							isLoading: true,
						}));
					}
				},
				handleCloseConfirmation: () =>
					setConfirmationModal({ isOpen: false, isLoading: false }),
			});
		},
	},
	multipleBuyerOrderAndPreviewProductionPlan: {
		getDisabled: ({ state, tableData }) => {
			return state?.buyer?.length === 0 || !state?.fromStore || !state?.expectedDeliveryDate || tableData?.rows?.length === 0;
		},
		onClick: ({
			state,
			lists,
			tableData,
			setConfirmationModal,
			proceedGenerateProductionPlan,
			selectedPOs,
			ppId,
			editMode,
			changeQtyRef,
		}) => {
			const redRows = tableData.rows.filter((row) => row._isNotFound);
			if (redRows.length > 0) {
				notificationServices.generateNotification({
					type: 'warning',
					message: `Cannot submit data. Please select products for ${redRows.length} red-highlighted items.`,
				});

				return;
			}
			setConfirmationModal({
				isOpen: true,
				heading: 'Save Multiple Buyer Order',
				message: `Are you sure you want to save the multiple buyer orders and Preview Production Plan?`,
				handleConfirmSave: async () => {
					setConfirmationModal((prev) => ({
						...prev,
						isLoading: true,
					}));
					try {
						const data = multipleConfigPo?.buyerDeserlizer(
							state,
							tableData
						);
						const response =
							await inventoryAnalyticsServices?.addVendorPO({
								data: {
									...data,
								},
							});
						if (response?.statusCode === 200) {
							notificationServices.generateNotification({
								type: 'success',
								message: response?.message,
							});
							proceedGenerateProductionPlan(
								response?.data?.orders
							);
						}
					} catch (error) {
						console.error(error);
					} finally {
						setConfirmationModal((prev) => ({
							...prev,
							isLoading: false,
						}));
					}
				},
				handleCloseConfirmation: () =>
					setConfirmationModal({ isOpen: false, isLoading: false }),
			});
		},
	},
};
